for (const el of document.getElementsByClassName('blog-view')) {
    el.addEventListener('click', () => {
        naja.makeRequest('POST', el.dataset.link, {
                type: el.dataset.blogView
            }, {
                history: false
            }
        ).then(_ => {
            document.getElementById('blog-view-list').classList.remove('active');
            document.getElementById('blog-view-grid').classList.remove('active');
            el.classList.add('active');
        })
    })
}

document.querySelectorAll(".sub-menu.show").forEach(el => el.parentNode.classList.add("active"));
